import translations from './translations.generated.json';
import type { Lang } from './i18n';

type BaseLang = 'en' | 'fr' | 'id';
export const EXTRA_LANGS = ['ar','de','es','hi','it','ja','ko','ms','nl','pt-BR','ru','zh-CN'] as const;
export type Translate = (message: string, values?: readonly unknown[]) => string;
const dictionaries: Record<string, Record<string, string>> = translations;

/** Prebuilt dictionaries only: no translation requests or added startup waits. */
export function translator(lang: Lang): Translate {
  return (message, values = []) => {
    const template = dictionaries[lang]?.[message] ?? message;
    return template.replace(/\{(\d+)\}/g, (_match, index: string) => String(values[Number(index)] ?? ''));
  };
}

export function expandLocales<T>(base: Record<BaseLang, T>, factory: (tr: Translate) => T): Record<Lang, T> {
  const result = { ...base } as Record<Lang, T>;
  for (const lang of EXTRA_LANGS) result[lang] = factory(translator(lang));
  return result;
}
